export default __webpack_public_path__ + "static/media/wind-night.18cf9a48.svg";